export const brandColors = {
  brandOne: '#02315B',
  brandTwo: '#228300',
  brandThree: '#fff', // White included for Agria so brandThree type available for child themes
} as const;
